var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center text-gray-default bg-green-50 rounded-lg text-xs px-3 py-2"},[_c('RespectOutline',{staticClass:"w-4 h-4 mr-1.5"}),_vm._v(_vm._s(_vm.$t('respectCard.name'))+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }